// extracted by mini-css-extract-plugin
module.exports = {"icon":"icon_icon__sq0kR","block":"icon_block__9Nmtz"};